<template lang="pug">
  .store-address
    span.label.font-weight-bold {{ $rogue.site.pickup.title }}
    br
    span.address {{ pickup.street.join(' ') }}
    br
    span.state {{ pickup.city }}, {{ pickup.region }} {{ pickup.postcode }}
    br
    a.map-link(
      :href="$rogue.site.pickup.mapsUrl"
      :alt="$rogue.site.pickup.title"
      rel="noopener noreferrer"
      target="_blank"
    ) {{ __('Get Directions') }}
    br
    br
    span.label.font-weight-bold {{ __('Pick-Up Hours:') }}
    br
    span.pickup-hours(v-for="(hours, index) in $rogue.site.pickup.hours" :key="index") {{ hours }} #[br]
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useRogue } from '@/js/services/Rogue'

const rogue = useRogue()
const pickup = computed(() => rogue.site.pickup?.address)
</script>

<style lang="scss" scoped>
  .store-address {
    text-align: center;

    .address, .state, .pickup-hours, .map-link {
      font-size: $size-xxs;
    }
  }
</style>
